import { domain } from "../../../domain";

export {
    income
}

function income(selectDate,fromDate,toDate){
    return `${domain}/pos/pos-report-income?selectDate=${selectDate}&fromDate=${fromDate}&toDate=${toDate}`;
}


